import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const inp = { width: '100%', padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', fontFamily: 'inherit', color: '#111827', background: '#fff', boxSizing: 'border-box' };
const btn = { width: '100%', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontWeight: 700, fontSize: '15px', cursor: 'pointer' };
const label = { display: 'block', fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '6px' };
const field = { marginBottom: '18px' };

export default function PartnerSignup() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState('loading'); // loading | ready | submitting | done | error | expired | used
  const [info, setInfo] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [tobAccepted, setTobAccepted] = useState(false);
  const [showTob, setShowTob] = useState(false);

  useEffect(() => {
    fetch(`/api/partners/invite-accept?token=${token}`)
      .then(r => {
        if (r.status === 410) return setState('expired');
        if (r.status === 404) return setState('used');
        if (!r.ok) return setState('error');
        return r.json().then(d => { setInfo(d); setState('ready'); });
      })
      .catch(() => setState('error'));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setErrorMsg('Password must be at least 8 characters');
    if (password !== confirm) return setErrorMsg('Passwords do not match');
    if (!tobAccepted) return setErrorMsg('You must accept the Terms of Business to continue');

    setState('submitting'); setErrorMsg('');
    try {
      const r = await fetch('/api/partners/invite-confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password, tob_accepted: true }),
      });
      const d = await r.json();
      if (!r.ok) { setErrorMsg(d.error || 'Something went wrong'); setState('ready'); return; }
      localStorage.setItem('token', d.token);
      localStorage.setItem('userRole', d.user.role);
      localStorage.setItem('userName', d.user.name);
      navigate('/partner/portal');
    } catch {
      setErrorMsg('Network error — please try again');
      setState('ready');
    }
  };

  const card = {
    minHeight: '100vh', background: '#f7fafc',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
  };
  const box = {
    background: '#fff', borderRadius: '16px', padding: '40px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)', maxWidth: '480px', width: '100%',
  };
  const logo = { fontSize: '22px', fontWeight: 800, marginBottom: '32px', display: 'block' };

  if (state === 'loading') return (
    <div style={card}><div style={box}>
      <span style={{ ...logo }}><span style={{ color: '#10b981' }}>Broker</span><span style={{ color: '#0e1b2c' }}>Connect</span></span>
      <p style={{ color: '#6b7280', textAlign: 'center' }}>Loading your invitation…</p>
    </div></div>
  );

  if (state === 'expired') return (
    <div style={card}><div style={box}>
      <span style={logo}><span style={{ color: '#10b981' }}>Broker</span><span style={{ color: '#0e1b2c' }}>Connect</span></span>
      <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '16px', color: '#991b1b', fontSize: '14px' }}>
        <strong>Invite expired.</strong> This invite link has expired. Please contact BrokerConnect to request a new one.
      </div>
    </div></div>
  );

  if (state === 'used') return (
    <div style={card}><div style={box}>
      <span style={logo}><span style={{ color: '#10b981' }}>Broker</span><span style={{ color: '#0e1b2c' }}>Connect</span></span>
      <div style={{ background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '8px', padding: '16px', color: '#92400e', fontSize: '14px' }}>
        <strong>Already used.</strong> This invite has already been accepted. <a href="/login" style={{ color: '#0e1b2c', fontWeight: 600 }}>Log in here</a>.
      </div>
    </div></div>
  );

  if (state === 'error') return (
    <div style={card}><div style={box}>
      <span style={logo}><span style={{ color: '#10b981' }}>Broker</span><span style={{ color: '#0e1b2c' }}>Connect</span></span>
      <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '16px', color: '#991b1b', fontSize: '14px' }}>
        Something went wrong loading your invitation. Please try again or contact BrokerConnect.
      </div>
    </div></div>
  );

  return (
    <div style={card}>
      <div style={box}>
        <span style={logo}><span style={{ color: '#10b981' }}>Broker</span><span style={{ color: '#0e1b2c' }}>Connect</span></span>
        <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#0e1b2c', margin: '0 0 6px' }}>Set up your partner account</h1>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 28px' }}>
          You're joining BrokerConnect as the portal contact for <strong style={{ color: '#0e1b2c' }}>{info?.partner_name}</strong>.
        </p>

        {errorMsg && (
          <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '12px 14px', color: '#991b1b', fontSize: '13px', marginBottom: '18px' }}>
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={field}>
            <label style={label}>Email address</label>
            <input style={{ ...inp, background: '#f9fafb', color: '#6b7280' }} value={info?.email || ''} readOnly />
          </div>
          <div style={field}>
            <label style={label}>Set your password</label>
            <input style={inp} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Minimum 8 characters" required />
          </div>
          <div style={field}>
            <label style={label}>Confirm password</label>
            <input style={inp} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat your password" required />
          </div>

          {/* Terms of Business */}
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '16px', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <span style={{ fontSize: '13px', fontWeight: 700, color: '#0e1b2c' }}>Partner Terms of Business</span>
              <button type="button" onClick={() => setShowTob(!showTob)}
                style={{ background: 'none', border: 'none', fontSize: '12px', color: '#6366f1', cursor: 'pointer', fontWeight: 600, padding: 0 }}>
                {showTob ? 'Hide' : 'Read terms'}
              </button>
            </div>

            {showTob && (
              <div style={{ fontSize: '12px', color: '#374151', lineHeight: 1.6, maxHeight: '260px', overflowY: 'auto', marginBottom: '12px', paddingRight: '4px' }}>
                <p><strong>1. Definitions.</strong> "BrokerConnect" means Giles Financial Services Ltd (trading as BrokerConnect). "Partner" means the service provider accepting these terms.</p>
                <p><strong>2. Appointment.</strong> BrokerConnect appoints the Partner as a non-exclusive service partner to receive client referrals via the platform.</p>
                <p><strong>3. Referrals.</strong> Referrals are subject to client GDPR consent. The Partner must contact referred clients within 5 business days and provide outcome updates via the portal.</p>
                <p><strong>4. Commission.</strong> Commission rates are as agreed and shown in the Partner portal. BrokerConnect will pay introducers their agreed share from commission received.</p>
                <p><strong>5. Data Protection.</strong> The Partner must hold a valid ICO registration and process personal data in compliance with UK GDPR and the Data Protection Act 2018.</p>
                <p><strong>6. Fees.</strong> The introductory period is zero-fee. BrokerConnect reserves the right to introduce platform fees with not less than 28 days' written notice. The Partner may exit without penalty within that 28-day window.</p>
                <p><strong>7. Regulatory.</strong> The Partner is responsible for maintaining all required regulatory authorisations. Nothing in these terms constitutes financial advice.</p>
                <p><strong>8. Confidentiality.</strong> Both parties agree to keep confidential all non-public information shared through the platform.</p>
                <p><strong>9. Liability.</strong> BrokerConnect's liability is limited to fees paid in the 12 months preceding any claim. Neither party is liable for indirect losses.</p>
                <p><strong>10. Termination.</strong> Either party may terminate with 30 days' written notice. BrokerConnect may terminate immediately for material breach.</p>
                <p><strong>11. Amendments.</strong> BrokerConnect may update these terms with 14 days' notice. Continued use of the portal constitutes acceptance.</p>
                <p><strong>12. Governing Law.</strong> These terms are governed by the laws of England and Wales.</p>
                <p><strong>13. Entire Agreement.</strong> These terms constitute the entire agreement between the parties in relation to the subject matter herein.</p>
              </div>
            )}

            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
              <input type="checkbox" checked={tobAccepted} onChange={e => setTobAccepted(e.target.checked)}
                style={{ marginTop: '2px', width: '16px', height: '16px', flexShrink: 0, cursor: 'pointer' }} />
              <span style={{ fontSize: '13px', color: '#374151', lineHeight: 1.5 }}>
                I have read and accept the <strong>BrokerConnect Partner Terms of Business</strong> on behalf of {info?.partner_name}.
              </span>
            </label>
          </div>

          <button type="submit" style={{ ...btn, opacity: state === 'submitting' ? 0.7 : 1 }} disabled={state === 'submitting'}>
            {state === 'submitting' ? 'Setting up your account…' : 'Create Account & Access Portal'}
          </button>
        </form>

        <p style={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', marginTop: '20px' }}>
          By creating an account you confirm you are authorised to accept these terms on behalf of {info?.partner_name}.
        </p>
      </div>
    </div>
  );
}
